import { TCGRow } from "../../tcg-components/row/row.component.js";
class CHCRow extends TCGRow {
}
export {
  CHCRow
};
//# sourceMappingURL=row.component.js.map
